// DOCSBUG5 (docs/build-briefs/DOCSBUG5-pay-sheet-test-wording.md): the words on
// the Pay sheet that depend on whether the payment can reach real money. No DOM,
// so a plain node:test file covers it (test/pay-confirm-wording.test.ts) and
// ui/src/main.ts's updatePayConfirmSummary applies it.
//
// The one signal is the server's own `testEnvironment` on the payment preview,
// which is the payment adapter's isTestEnvironment() (TERM2). Anything but an
// explicit true is treated as live, the same rule the adapter interface states,
// so a server that fails to say never shows "no card charged".

export interface PayConfirmWording {
  /** The Confirm button's text. */
  confirmLabel: string;
  /** The header badge. Absent for a live payment. */
  badgeText?: string;
  /** The line under the button. Absent for a live payment. */
  noteText?: string;
}

export function payConfirmWording(testEnvironment: boolean | undefined): PayConfirmWording {
  if (testEnvironment === true) {
    return {
      confirmLabel: "Confirm Test Payment",
      badgeText: "Test payment, no card charged",
      noteText: "Test payment only. No card is charged.",
    };
  }
  return { confirmLabel: "Confirm Payment" };
}
